import React, { createContext, useContext, useState, useCallback } from "react";
import ToastMessages from "./toasts";

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState({ open: false, message: "", type: "info" });

  const showToast = useCallback((message, type = "info") => {
    setToast({ open: true, message, type });
  }, []);

  const closeToast = () => setToast({ ...toast, open: false });

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <ToastMessages
        open={toast.open}
        setOpen={closeToast}
        toastMessage={toast.message}
        type={toast.type}
      />
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);
